import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class ResourceDbserverApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'resourceDbserver';
    }
    /**
     * 保存多条数据
     * @param datas 
     * @returns 
     */
    public async resourceDbserverSaveOrUpdate(datas) {
        return await this.send(datas, 'resourceDbserverSaveOrUpdate', Methods.POST);
    } 
    /**
     * 保存单挑记录
     * @param entity 
     * @returns 
     */
    public SaveEntity(entity:any){
        return this.send(entity,"update",Methods.POST);
    }
    /**
     * 保存密码
     * @param data 
     * @returns 
     */
    public resetPwd(data) {
        return this.send(data, 'resetPwd', Methods.POST);
    }
    /**
     * 删除记录
     * @param Id 
     * @returns 
     */
    public RemoveEntity(Id:number)
    {
        return this.send({},"delete?Id="+Id,Methods.POST);
    }
    /**
     * 按数据库应用场景获取集群配置信息（dev\gray\pro）
     * @param scene 
     * @returns 
     */
    public getEntityListByScene(scene:string){
        return this.send({devProd:scene},"getEntityList",Methods.GET);
    }
    /**
     * 获取dbserver 扩展属性
     * @param dbsid 
     * @returns 
     */
    public DBSAttributesByDBSId(dbsId:number){
        return this.send({dbsId},"getdbserverAttributes",Methods.GET);
    }
}